
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schwangerschaftsbetreuung",
      function () {
        return require("private-next-pages/schwangerschaftsbetreuung/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schwangerschaftsbetreuung"])
      });
    }
  